import { module } from 'modujs';
import gsap from "gsap";

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.hero = this.el.querySelector('.c-hero');
        if (this.hero) {
            this.title = this.hero.querySelector('.-h1');
            this.introduction = this.hero.querySelector('.c-hero_introduction');
            this.covers = this.hero.querySelectorAll('.c-hero_cover_media');
            this.scrollButton = this.hero.querySelector('.c-hero_scroll');
        }
        this.formWrap = document.body.classList.contains('page-template-tpl-contact-php')
            ? this.el.querySelector('.formWrap')
            : null;
        this.mainContent = this.el.querySelector('.mainContent');
        this.navbar = document.querySelector('.c-navbar');
        this.heroAnimated = false;
        this.heroIntroPrepared = false;

        this.onPLoaded = () => {
            if (this.heroAnimated) return;
            this.heroAnimated = true;
            this.animate();
        };

        window.addEventListener('p-loaded', this.onPLoaded);
    }

    destroy() {
        if (this.onPLoaded) {
            window.removeEventListener('p-loaded', this.onPLoaded);
        }
        this.heroIntroPrepared = false;
        this.heroAnimated = false;
    }

    prepIntro() {
        if (this.heroIntroPrepared) return;
        this.heroIntroPrepared = true;

        if (this.covers?.length) {
            gsap.set(this.covers, { scale: 1.3 });
        }

        if (this.title) {
            gsap.set(this.title.querySelectorAll('.word'), {
                y: '100%',
                rotate: 10,
                opacity: 0,
            });
        }

        if (this.scrollButton) {
            gsap.set(this.scrollButton, { scale: 0 });
        }

        if (this.introduction) {
            gsap.set(this.introduction.querySelectorAll('.line'), {
                opacity: 0,
                y: 30,
            });
        }

        if (this.mainContent) {
            gsap.set(this.mainContent, { opacity: 0, y: 80 });
        }

        if (this.formWrap) {
            gsap.set(this.formWrap, { opacity: 0, y: 80 });
        }

        if (this.navbar) {
            gsap.set(this.navbar, { opacity: 0, y: -16 });
        }
    }

    animate() {
        const tl = gsap.timeline();

        if (this.covers?.length) {
            tl.fromTo(this.covers,
                { rotate: 0, scale: 1.3 },
                { rotate: 0, scale: 1, ease: 'circ.out', duration: 1.2 },
                0
            );
        }

        if (this.navbar) {
            tl.fromTo(this.navbar,
                { opacity: 0, y: -16 },
                { opacity: 1, y: 0, ease: 'expo.out', duration: 0.6 },
                0
            );
        }

        if (this.title) {
            tl.fromTo(this.title.querySelectorAll('.word'),
                { y: '100%', rotate: 10, opacity: 0 },
                { y: '0%', rotate: 0, opacity: 1, ease: 'expo.out', duration: 0.8, stagger: 0.06 },
                0.1
            );
        }

        if (this.introduction) {
            tl.fromTo(this.introduction.querySelectorAll('.line'),
                { opacity: 0, y: 30 },
                { opacity: 1, y: 0, ease: 'expo.out', duration: 0.6, stagger: 0.06 },
                0.2
            );
        }

        if (this.mainContent) {
            tl.fromTo(this.mainContent,
                { opacity: 0, y: 80 },
                { opacity: 1, y: 0, ease: 'expo.out', duration: 0.8 },
                0.25
            );
        }

        if (this.formWrap) {
            tl.fromTo(this.formWrap,
                { opacity: 0, y: 80 },
                { opacity: 1, y: 0, ease: 'expo.out', duration: 0.8 },
                0.25
            );
        }

        if (this.scrollButton) {
            tl.fromTo(this.scrollButton,
                { scale: 0 },
                { scale: 1, ease: 'expo.out', duration: 0.6 },
                0.4
            );
        }
    }
}
